import React, { Fragment } from "react"
import { graphql } from "gatsby"

import Layout from "components/Layout"
import Breadcrumbs from "components/Breadcrumbs"
import PageHeader from "components/PageHeader"
import ContactGlobal from "components/ContactGlobal"

import { Hero, Content } from "page_components/investments"

const Investment = ({ data }) => {
  const title = "Warmia i Mazury"

  const dataInvestment = {
    background:
      require("assets/images/investments/investment-hero-background-lakes.jpg")
        .default,
    icon: require("assets/images/investments/investment-hero-icon-lakes.svg")
      .default,
    description: (
      <Fragment>
        <li>Dzika przyroda w otoczeniu jezior</li>
        <li>Dostęp do infrastruktury wodnej</li>
        <li>Czyste powietrze</li>
      </Fragment>
    ),
    investemnts: data?.allWpInvestment?.nodes?.length,
    region: "lakes",
  }

  return (
    <Layout
      seo={{
        title: title,
        description:
          "Atrakcyjne inwestycje na Warmii i Mazurach. Zainwestuj w rozwijający się rynek nieruchomości w malowniczych regionach Polski. Planuj swoją przyszłość finansową już dziś!",
      }}
    >
      <Breadcrumbs
        title={title}
        parent={{
          title: "Portfel nieruchomości",
          path: "/portfel-nieruchomosci/",
        }}
      />
      <PageHeader title={title} />
      <Hero
        background={dataInvestment.background}
        icon={dataInvestment.icon}
        description={dataInvestment.description}
        investemntsLenght={dataInvestment.investemnts}
        allInvestemnts={data?.allWpInvestment?.nodes}
      />
      <Content data={data?.allWpInvestment?.nodes} />
      <ContactGlobal />
    </Layout>
  )
}

export const query = graphql`
  query {
    allWpInvestment(
      filter: {
        acfInvestment: { region: { eq: "lakes" }, status: { eq: "sell" } }
      }
      sort: { fields: acfInvestment___position, order: ASC }
    ) {
      nodes {
        id
        title
        uri
        slug
        acfInvestment {
          apartmensNumber
          areaNumberMin
          areaNumberMax
          apartmenPriceMin
          address
          status
          region
          logo {
            sourceUrl
          }
          images {
            sourceUrl
          }
          excerpt
          mapContent {
            latitude
            longitude
          }
        }
      }
    }
  }
`

export default Investment
